// Import libs
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

// Import assets
import './ambassadorsView.scss';

// Import components
import LenspireView from '../LenspireView';
import TileContainer from '../../Components/Tiles/TileContainer/TileContainerController';
import { fetchAmbassadors } from '../../Base/Actions/ambassadorsActions';

class AmbassadorsView extends React.Component {
  static shuffle(a) {
    const s = a;
    for (let i = s.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [s[i], s[j]] = [s[j], s[i]];
    }
    return s;
  }

  componentWillMount() {
    this.props.fetchAmbassadors(this.props.match.params.lang);
  }

  render() {
    const ambassadorsData = AmbassadorsView.shuffle(this.props.ambassadorsData);

    return (
      <LenspireView {...this.props} className={'o-ambassadors'}>
        <TileContainer tilesData={ambassadorsData} />
      </LenspireView>
    );
  }
}

function mapStateToProps(state) {
  return {
    ambassadorsData: state.ambassadorsState.ambassadors,
    meta: state.globalsState.meta,
    error: state.globalsState.error,
    lang: state.globalsState.lang,
    isLoading: state.loaderState.isLoading,
  };
}

AmbassadorsView.propTypes = {
  ambassadorsData: PropTypes.arrayOf(PropTypes.shape({
    headline: PropTypes.string,
    subline: PropTypes.string,
    image: PropTypes.shape({
      sm: PropTypes.string,
      md: PropTypes.string,
      lg: PropTypes.string,
      xl: PropTypes.string,
      xxl: PropTypes.string,
      default: PropTypes.string,
    }),
  })),
  fetchAmbassadors: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
  error: PropTypes.string,
  lang: PropTypes.string,
};

AmbassadorsView.defaultProps = {
  ambassadorsData: [
    {
      headline: '',
      subline: '',
      image: {},
    },
  ],
  error: '',
  lang: 'en',
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAmbassadors }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AmbassadorsView);



// WEBPACK FOOTER //
// ./frontend/js/Views/AmbassadorsView/AmbassadorsView.jsx